(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blossom-pickup-banner"] && !Shopify.designMode) return;
  try {
    
const initBfTicker=()=>{document.querySelectorAll('[data-bf-ticker]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';const b=el.querySelector('button');b.addEventListener('click',()=>{const p=el.classList.toggle('is-paused');b.setAttribute('aria-pressed',String(p));b.setAttribute('aria-label',p?b.dataset.play:b.dataset.pause);b.textContent=p?'▶':'Ⅱ';});});};initBfTicker();document.addEventListener('shopify:section:load',initBfTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
